import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  SimpleDataTable as DataTable,
  Loader,
  ButtonOBSOLETED,
  Notification,
  Message
} from '../../web.common';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import { Filters, FilterInput, FilterSelect, FilterTimePicker } from './Filters';
import { getQueryStringParameters } from '../../common/utils';
import { transactionStatus } from '../../enums/transactionStatus';
import {
  DisplayCurrencyAmount,
  DisplayDate,
  DisplayGuid,
  DisplayStatus
} from '../items';

const resultsCount = 15;

class TransactionsInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false };
  }

  goToPage(number) {
    // TODO consider to move responsability to filter component
    const { history, location } = this.props;
    const filters = Object.assign(
      {},
      getQueryStringParameters(location.search),
      {
        page: number
      });
    const search = Object.keys(filters)
      .filter(key => key && filters[key])
      .map(key => `${key}=${encodeURIComponent(filters[key])}`).join('&');
    history.push(`?${search}`);
  }

  async loadData(filters, skipPages) {
    const { props: { api: { transactions: { searchTransaction } } } } = this;

    this.setState({ isLoading: true });
    let result = null;

    try {
      result = await searchTransaction({ filters, skipPages, resultsCount });
    }
    catch (e) {
      console.error(`unable to load. ${e}`);
      this.setState({ isLoading: false, errorMessage: new Message('error', 'Unable to load data') });

      return;
    }

    this.setState({ isLoading: false });

    return result;
  }

  render() {
    const { history, location } = this.props;
    const { isLoading, errorMessage } = this.state;
    const parameters = getQueryStringParameters(location.search);
    const pageNumber = parameters.page ? parseInt(parameters.page, 10) : 1;

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <Notification newMessage={errorMessage} />
            <PageTop
              documentTitle='Transactions list'
              documentDescription='Transactions list'
            />
            <h2 className='main-page-header'>
              Transactions
            </h2>
            <Filters
              initFromUrl
              submitUrl
              validateForm={({
                subscriptionId,
                transactionId,
                purchaseId,
                status,
                paymentMethodId,
                afterAt,
                beforeAt
              }, updatedKey) => {
                if (updatedKey !== 'transactionId') {
                  return {
                    subscriptionId,
                    purchaseId,
                    status,
                    paymentMethodId,
                    afterAt,
                    beforeAt
                  };
                }
                return { transactionId };
              }}
              render={(formData, update) => (
                <div className='filters-block'>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='transactionId'>
                      Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='transactionId'
                      placeholder='Find by id'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='subscriptionId'>
                      Subscription Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='subscriptionId'
                      placeholder='Filter by subscription id'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='purchaseId'>
                      Purchase Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='purchaseId'
                      placeholder='Filter by purchase id'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='paymentMethodId'>
                      Payment Method Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='paymentMethodId'
                      placeholder='Filter by payment method id'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='afterAt'>
                      From
                    </label>
                    <FilterTimePicker
                      className='filter-date-picker'
                      data={formData}
                      update={update}
                      name='afterAt'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='beforeAt'>
                      To
                    </label>
                    <FilterTimePicker
                      className='filter-date-picker'
                      data={formData}
                      update={update}
                      name='beforeAt'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='status'>
                      Status
                    </label>
                    <FilterSelect
                      className='filter-select'
                      data={formData}
                      update={update}
                      name='status'
                      options={transactionStatus}
                    />
                  </div>
                  <br />
                  <br />
                  <div className='filters-submit-wrapper'>
                    <ButtonOBSOLETED type='submit' buttonContent='Search' disabled={isLoading} />
                  </div>
                  <hr />
                </div>
              )}
            />
            <DataTable
              style={{ marginTop: '100px' }}
              loadingContent={(<Loader hasLoaded={false} />)}
              tableConfig={{
                tableName: 'transactions',
                rowClasses: 'hover-listview',
                rowClick: ({ Id }) => {
                  history.push(`/transaction/${Id}`);
                },
                columns: [
                  {
                    property: 'Id',
                    label: 'Id',
                    render: ({ Id }) => <DisplayGuid>{Id}</DisplayGuid>
                  }
                  ,{
                    property: 'Total',
                    label: 'Total',
                    render: ({ GrandTotal, CurrencyIsoCode }) =>
                      <DisplayCurrencyAmount amount={GrandTotal} alignRight currency={CurrencyIsoCode} />
                  }
                  , {
                    property: 'Status',
                    label: 'Status',
                    render: ({ Status }) => <DisplayStatus mapping={transactionStatus}>{Status}</DisplayStatus>
                  }, 
                  ,{
                    property: 'Created At (CET)',
                    label: 'Created At (CET)',
                    render: ({ CreatedAtCet }) => <DisplayDate>{CreatedAtCet}</DisplayDate>
                  }
                ]
              }}
              getData={async newPageNumber => {
                const filters = getQueryStringParameters(location.search);
                return this.loadData(filters, newPageNumber || 1);
              }}
              paginationData={{
                renderLocation: 'both',
                rowsPerPage: resultsCount,
                pageNumber,
                goToPageNumber: number => this.goToPage(number)
              }}
              skipTableNoResults
              cellVerticalAlign='top'
              hideTableHead={false}
              languageCode='en'
              labels={{
                tableBody: {
                  noResult: <div style={{ display: 'block', textAlign: 'center' }}>No Results</div>
                }
              }}
              cellContent='cellContent'
            />
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const Transactions = withRouter(withApi(connect(({ user }) => ({ isLoggedIn: !!user }), {})(TransactionsInternal)));

Transactions.requiresLogin = true;
Transactions.propTypes = { isLoggedIn: PropTypes.bool };

export default Transactions;
